import { useState } from "react";
import * as ReactBootStrap from "react-bootstrap";

function PrefillApi() {
    const [status, setStatus] = useState();
    const [panNumber, setPanNumber] = useState();
    const [panStatus, setPANStatus] = useState()
    const [firstname, setFirstName] = useState()
    const [dob, setDOB] = useState()
    const [remark, setRemark] = useState()
    const [lastupdated, setPanLastUpdated] = useState()
    const [isAdadharLinked, setIsAdadharLinked] = useState()
    const [values, setValues] = useState({ name: "", panname: ""  , middle_name : "" , last_name: "" , mob_no: "" , request_id: ""});
    const [apiResponse, setApiResponse] = useState(null);
    const [loading , setLoading] = useState(true)


    const handleChange = (e) => {
        const { name, value } = e.target;
        console.log(name);
        console.log(value);

        const formFieldsObject = {
            ...values,
            [name]: value,
        };

        setValues(formFieldsObject);
    };

    const onSubmit = async (e) => {
        setLoading(false);

        e.preventDefault();

        // Generate a random caseId
        const randomCaseId = Math.floor(Math.random() * 1000000000).toString();

        // Prepare the payload with default consent and random caseId
        const payload = {
            first_name: values.name,
            middle_name : values.middle_name,
            last_name : values.last_name,
            mob_no : values.mob_no,
            request_id: values.request_id,

            // consent: "Y",
           
            //     request_id: randomCaseId,
           
        };

        // Make the API request with the payload
        await fetch(
            'https://rsu92aeag7.execute-api.ap-south-1.amazonaws.com/default/equifax_uat_env?consent=1',
            {
                method: "POST",
                headers: {
                    "x-api-key": "AXDZGrz6af4jTI2YsPXyj8EPRtQcs1ek5XsVr60Z",
                    'client-secret-key': "JPpIkZDIFgVEnoPupCFzWH4K5F1R9184",
                    "Content-Type": "application/json", // Specify the content type
                     'authorizationToken': 'O68am48nB65zJcrQ'
                },

                body: JSON.stringify(payload), // Convert the payload to JSON format
            }
        )
            .then((res) => res.json())
            .then((data) => {
                console.log(data);
                setStatus(data.status);
                setFirstName(data.name);
                setPANStatus(data.pan_status)
                setDOB(data.dob);
                setApiResponse(data);
                setLoading(true)


                setIsAdadharLinked(data.isaadhaarlinked);
                setRemark(data.remark)
                console.log(data.setBeneficiaryNameWithBank);
                sessionStorage.setItem("Name", "");
            })
            .catch(function (error) {
                setLoading(true)
                alert("Something went wrong with server");
                // console.log(error);
              });
    };


    return (
        <div>
                  
            <div>
                <div className="container containerBoreder " id="pan">
                    <h2 class="pageTitle">Prefill API</h2>
                    <div class="row">
                    <div className="col-4">
    <div className="form-group">
        <label htmlFor="first_name">First Name</label>
        <input
            type="text"
            className="form-control"
            id="first_name"
            name="name"
            placeholder="Your First Name"
            value={values.name}
            onChange={handleChange}
        />
    </div>
    <div className="form-group">
        <label htmlFor="middle_name">Middle Name</label>
        <input
            type="text"
            className="form-control"
            id="middle_name"
            name="middle_name"
            placeholder="Your Middle Name"
            value={values.middle_name}
            onChange={handleChange}
        />
    </div>
    <div className="form-group">
        <label htmlFor="last_name">Last Name</label>
        <input
            type="text"
            className="form-control"
            id="last_name"
            name="last_name"
            placeholder="Your Last Name"
            value={values.last_name}
            onChange={handleChange}
        />
    </div>
    <div className="form-group">
        <label htmlFor="mob_no">Mobile Number</label>
        <input
            type="text"
            className="form-control"
            id="mob_no"
            name="mob_no"
            placeholder="Your Mobile Number"
            value={values.mob_no}
            onChange={handleChange}
        />
    </div>
    <div className="form-group">
        <label htmlFor="request_id">Request ID</label>
        <input
            type="text"
            className="form-control"
            id="request_id"
            name="request_id"
            placeholder="Request ID"
            value={values.request_id}
            onChange={handleChange}
        />
    </div>
</div>

{loading?(<div className="col-4">
              <button className="btn btn-primary" onClick={onSubmit}>
                Submit
              </button>
            </div>) :<ReactBootStrap.Spinner animation="border" />}
                        {/* <div class="col-4">
                            <button class="btn btn-primary" type="submit" onClick={onSubmit}>
                                Submit
                            </button>
                        </div> */}
                    </div>
                    <br />
                    <table className="table">
    <tbody>
        {apiResponse &&
            Object.entries(apiResponse).map(([key, value]) => (
                <tr key={key}>
                    <th>{key.toUpperCase()}</th>
                    <td>
                        {Array.isArray(value)
                            ? value.map((item, index) => (
                                  <div key={index}>
                                     ( {index + 1}). {item}
                                  </div>
                              ))
                            : value}
                    </td>
                </tr>
            ))}
    </tbody>
</table>


                </div>
            </div>
        </div>
    );
}

export default PrefillApi;
